webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_sass_main_sass__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_sass_main_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_sass_main_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* global akdev_vars */



__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.contacts-button').click(function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#contact-modal').fadeIn();
    document.body.classList.add('body_clipped');
  });

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal__close').click(function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).parents('.modal').fadeOut();
    document.body.classList.remove('body_clipped');
  });

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#feedback-modal').submit(function (e) {
    e.preventDefault();
    var submitButton = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#contact-form-submit');
    submitButton.addClass('button_loading');

    var form = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
    // const nonce = $('input[name="nonce"]', form).val()

    window.grecaptcha.ready(function () {
      window.grecaptcha.execute('6LerLy8nAAAAAN0vedQRA4S9F9fd852TIY0Lk2Oh', { action: 'submit' }).then(function (recaptchaToken) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('input[name="recaptcha"]', form).val(recaptchaToken);

        var data = new FormData(form[0]);
        data.append('action', 'feedback_form');

        fetch(akdev_vars.ajax_url, { method: 'POST', body: data }).then(function (res) {
          return res.json();
        }).then(function (res) {
          submitButton.removeClass('button_loading');
          if (res.success) {
            submitButton.addClass('button_sent');
            submitButton.html('Done');
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#contact-form__name').val('');
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#contact-form__about').val('');
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#contact-form__email').val('');
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#contact-form__number').val('');
            setTimeout(function () {
              submitButton.removeClass('button_sent');
              submitButton.html('Submit');
            }, 2000);
          } else {
            alert('Ошибка: ' + res.data.message);
          }
        }).catch(function () {
          submitButton.removeClass('button_loading');
          alert('Ошибка при отправке формы');
        });
      });
    });
  });

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#nav__menu-button').click(function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#nav').toggleClass('nav_active');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').toggleClass('body_clipped');
  });

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#main-page-get-in-touch-button').click(function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html, body').animate({
      scrollTop: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#main-page-get-in-touch').offset().top
    }, 1000);
  });
});

/***/ })
],[2]);


// WEBPACK FOOTER //
// static/js/app.68c62a63b9c6c035388d.js